<!-- 
    FORM PARA INCLUSAO DE ORGANIZACOES
-->

<script>
import { apiORDSpost, apiORDS } from '../shared/api-functions'
import { SysVars } from '../main';
import InputColor from '../components/input-color'
import Vue from 'vue';
import CrmTagForm from './crm-tag-form'
import apiCrm from '../api/api-crm.js'

export default {
    props: {
        index: '',
        crud: '',
        transformarPart: Boolean,   //para transformar a organização em cliente
    },
    
    components: {
        InputColor, CrmTagForm
    },

    data () {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,
            showTagForm: false,
            codtag: null,
            crudTag: '',
            part: {...this.$store.getters.getEntities.part},
            orgcrm: {...this.$store.getters.getEntities.orgcrm},

            inputNome: {
                url: '/crm/find/organizacao?nome=',
                permite_novo: false,
                duplicados: true,
                codigo: null,
                icon: 'fa-university', 
            },

        }
    },

    mixins: [apiCrm],  //ROTINAS DO CRM

    computed: {

        nome: function () {
            return this.orgcrm.nome
        },

        dadosPart: function () {
            return this.orgcrm.cnpj
        },

    },

    methods: {
        updateCep () {
            //CARREGA INFORMACOES DO CEP DIGITADO            
            this.orgcrm.ende = SysVars.endereco.logradouro
            this.orgcrm.bairro = SysVars.endereco.bairro
            this.orgcrm.codmun = SysVars.endereco.ibge
            this.orgcrm.uf = SysVars.endereco.uf
            this.orgcrm.codpais = '1058'
        },

        handleSalvar () {
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Corrija os erros de preenchimento para continuar!')
                } else {
                    if (this.transformarPart) {
                        this.orgcrm.cliente = this.part
                    }
                    this.apiOrg(this.orgcrm, this.orgcrm.codorg, this.callBackPost)
                }
            })
        },

        handleAdicionarTag () {
            this.codtag = null
            this.crudTag = SysVars.crudI
            this.showTagForm = true
        },

        handleEditarTag (cod) {
            this.crudTag = SysVars.crudU
            this.codtag = cod
            this.showTagForm = true
        },

        handleCloseTag (tag) {
            this.$refs.etiqueta.loadData()
            if (tag)
               this.orgcrm.codtag = tag.codtag
            this.showTagForm = false
        },

        callBackPost (org) {
            this.closeForm(org)
        },

        closeForm (org) {
            this.$emit('closeform', org)
        },

        async loadData () {
            await this.$store.dispatch('loadOrganizacao', { id: this.index } )
            if (this.$store.getters.getOrganizacao) {
                this.orgcrm = {...this.$store.getters.getOrganizacao}
            }

            this.part.tpcliente = 'F'
            this.part.optsimples = 'N'
            this.part.zfranca = 'N'
            this.part.contricms = 'S'
        },

    },

    watch: {
        nome: function () {
            // console.log(this.nome)
        }

    },

    mounted () {
        this.$nextTick(function () {
            if (this.$refs.nome) {
               this.$refs.nome.focus()
            }
        })

    },

    created () {
        if (this.index) 
          this.loadData()
    }

}

</script>

<template>
    <div class="nb-modal-scrollable">
        <div class="container nb-modal-scrollable-container" style="width: 600px; max-width: 100%">
            <div class="nb-modal-header">
                <h4 class="def-title" v-if="orgcrm.codorg">Alterar Organização</h4>
                <h4 v-else class="def-title">Nova Organização</h4>
            </div>
            <div class="nb-modal-scrollable-body">
                <alert v-if="transformarPart" type="info" title="Aviso" text="Informe alguns dados obrigatórios para criação de um orçamento."></alert>

                <div class="row">
                    <div class="col-md-12">
                        <input-search ref="nome" v-model="orgcrm.nome" :params="inputNome" :metadata="metadata.orgcrm.nome"
                        name="nome" :v-errors="errors" v-validate="metadata.orgcrm.nome.validator"></input-search>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 col-12">  
                        <input-color ref="etiqueta" v-model="orgcrm.codtag" :params="{ edit: true, label: 'Etiqueta', url: 'crm/tag/list/pessoa' }" @editar="handleEditarTag" @adicionar="handleAdicionarTag"></input-color>
                    </div>
                </div>
                <div class="row">
                    <form-field v-model="orgcrm.codusuario" type="select2" col="6" :metadata="metadata.orgcrm.codusuario"
                        ref="usuario" name="codusuario" :v-errors="errors" v-validate="metadata.orgcrm.codusuario.validator"></form-field>
                </div>

                <div class="row">
                    <form-field v-model="orgcrm.cnpj" type="number" col="6" :metadata="metadata.orgcrm.cnpj" 
                        name="cnpj" :v-errors="errors" v-validate="metadata.orgcrm.cnpj.validator"></form-field>
                </div>

                <label-title title="Endereço" class="mb-2"></label-title>
                <div class="row pb-3">
                    <!-- <form-field v-model="orgcrm.cep" type="cep" col="3" :metadata="metadata.orgcrm.cep" 
                        name="cep" :v-errors="errors" v-validate="{max: 8}" @update="updateCep"></form-field>
                    <div class="w-100"></div>
                    <form-field v-model="orgcrm.ende" type="text" col="9" :metadata="metadata.orgcrm.ende" 
                        name="ende" :v-errors="errors" v-validate="{max: 100}"></form-field>
                    <form-field v-model="orgcrm.endenr" type="text" col="3" :metadata="metadata.orgcrm.endenr" 
                        name="endenr" :v-errors="errors" v-validate="{max: 40}"></form-field>
                    <form-field v-model="orgcrm.endecomp" type="text" col="6" :metadata="metadata.orgcrm.endecomp" 
                        name="endecomp" :v-errors="errors" v-validate="{max: 100}"></form-field>
                    <form-field v-model="orgcrm.bairro" type="text" col="6" :metadata="metadata.orgcrm.bairro" 
                        name="bairro" :v-errors="errors" v-validate="{max: 60}"></form-field>
                    <form-field v-model="orgcrm.uf" type="select2" col="6" :metadata="metadata.orgcrm.uf"
                        name="uf" :v-errors="errors" v-validate="metadata.orgcrm.uf.validator"></form-field> -->
                    <form-field v-model="orgcrm.codmun" type="select2" col="6" :metadata="metadata.orgcrm.codmun"
                        name="codmun" :v-errors="errors" v-validate=""
                        :select2="{entity: 'mun/', minlength: 2}"></form-field>
                    <!-- <form-field v-model="orgcrm.codpais" type="select2" col="6" :metadata="metadata.orgcrm.codpais"
                        name="codpais" :v-errors="errors" v-validate="metadata.orgcrm.codpais.validator"></form-field> -->
                </div>

                <!-- DADOS PARA CADASTRO DO CLIENTE E GERACAO DA PROPOSTA -->
                <div v-if="transformarPart">
                    <label-title title="Informações Necessárias Para Orçamento" class="mb-2"></label-title>
                    <div class="row mb-5">
                        <form-field v-model="part.contricms" type="select" col="4" :metadata="metadata.part.contricms"
                            name="contricms" :v-errors="errors" v-validate="metadata.part.contricms.validator"></form-field>
                        <form-field v-model="part.iest" type="text" col="4" :metadata="metadata.part.iest"
                            name="iest" :v-errors="errors" v-validate="metadata.part.iest.validator"></form-field>
                        <form-field v-model="part.optsimples" type="select" col="4" :metadata="metadata.part.optsimples"
                            name="optsimples" :v-errors="errors" v-validate="metadata.part.optsimples.validator"></form-field>
                        <form-field v-model="part.tpcliente" type="select" col="4" :metadata="metadata.part.tpcliente"
                            name="tpcliente" :v-errors="errors" v-validate="metadata.part.tpcliente.validator"></form-field>
                        <form-field v-model="part.zfranca" type="select" col="4" :metadata="metadata.part.zfranca" 
                            name="zfranca" :v-errors="errors" v-validate="metadata.part.zfranca.validator"></form-field>
                        <form-field v-if="part.zfranca == 'S'" v-model="part.inscsuframa" type="text" col="4" :metadata="metadata.part.inscsuframa" 
                            name="inscsuframa" :v-errors="errors" v-validate="metadata.part.inscsuframa.validator"></form-field>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <v-button label="Cancelar" class="float-right" icon="fa-arrow-left" @click="closeForm"></v-button>
                <v-button label="Salvar" class="float-right" :nb-btdef="true" @click="handleSalvar"></v-button>
            </div>

        </div>
        <crm-tag-form v-if="showTagForm" @closeform="handleCloseTag" tptag="P" :index="codtag" :crud="crudTag" ></crm-tag-form>

    </div>

</template>

<style>

</style>


// WEBPACK FOOTER //
// src/forms-crm/crm-org-novo-form.vue